import { __decorate } from "tslib";
import { PrivateAPINamespace } from '../PrivateAPINamespace';
import { ApiConfig, Frame } from '../../limitPrivateAPI';
let CustomElementNamespace = class CustomElementNamespace extends PrivateAPINamespace {
    getAttributes(compRef) {
        const data = this.ps.ds.components.data.get(compRef) ?? {};
        return JSON.parse(data?.initialAttributes ?? '{}');
    }
    getAttribute(compRef, attributeName) {
        const attributes = this.getAttributes(compRef);
        return attributes[attributeName];
    }
    setAttribute(compRef, attributeName, value) {
        const attributes = this.getAttributes(compRef);
        this.setAttributes(compRef, {
            ...attributes,
            [attributeName]: value,
        });
    }
    setAttributes(compRef, attrs) {
        // TODO: should reload?
        const data = this.ps.ds.components.data.get(compRef) ?? {};
        this.ps.ds.components.data.update(compRef, {
            ...data,
            initialAttributes: JSON.stringify(attrs),
        });
    }
    setPreloadFonts(compRef, fontFamilies) {
        const style = this.ps.ds.components.style.get(compRef) || {
            type: 'ComponentStyle',
            styleType: 'custom',
            skin: 'wixui.skins.CustomElement',
            componentClassName: 'wixui.CustomElementComponent',
            style: {
                properties: {},
                propertiesSource: {},
            },
        };
        const combinedFontFamilies = joinFontFamilies(fontFamilies);
        this.ps.ds.components.style.update(compRef, {
            ...style,
            style: {
                ...(style.style ?? {}),
                properties: {
                    ...(style.style?.properties ?? {}),
                    fontFamily: combinedFontFamilies,
                },
                propertiesSource: {
                    ...(style.style?.propertiesSource ?? {}),
                    fontFamily: 'value',
                },
            },
        });
    }
};
CustomElementNamespace.namespace = 'customElement';
CustomElementNamespace = __decorate([
    ApiConfig(Frame)
], CustomElementNamespace);
export { CustomElementNamespace };
const formatFontFamily = (fontFamily) => {
    if (fontFamily.startsWith(`"`) && fontFamily.endsWith(`"`)) {
        return fontFamily;
    }
    if (fontFamily.includes(' ')) {
        return `"${fontFamily}"`;
    }
    return fontFamily;
};
const joinFontFamilies = (fontFamilies) => {
    const uniqueFontFamilies = Array.from(new Set(fontFamilies));
    return uniqueFontFamilies.map(formatFontFamily).join(',');
};
//# sourceMappingURL=CustomElementNamespace.js.map